import type { FC, HTMLProps } from "react";
import { useEffect } from "react";

import { Form, PolicyCheckFields, useForm } from "@jti/ui";

type PolicyCheckFieldsFormValues = {
  isPolicyRead: boolean;
};

type PolicyCheckFieldsWrapperProps = {
  setIsPolicyRead(val: boolean): void;
} & HTMLProps<HTMLDivElement>;

export const PolicyCheckFieldsWrapper: FC<PolicyCheckFieldsWrapperProps> = ({ setIsPolicyRead, ...restProps }) => {
  const form = useForm<PolicyCheckFieldsFormValues>({
    reValidateMode: "onChange",
    defaultValues: {
      isPolicyRead: false,
    },
    shouldUnregister: false,
  });
  const { watch } = form;

  const isPolicyRead = watch("isPolicyRead");

  useEffect(() => {
    setIsPolicyRead(isPolicyRead);
  }, [setIsPolicyRead, isPolicyRead]);

  return (
    <div {...restProps}>
      <Form form={form} dataTestId="policyCheckFieldsWrapper">
        <PolicyCheckFields />
      </Form>
    </div>
  );
};
